<p-toast></p-toast>
<div class="card">
    <div class="p-fluid p-formgrid grid dropdown-card">

        <div class="field col-12 md:col-3">
            <label htmlFor="component">{{'APP_STATUS'| translate}}</label>
            <p-dropdown [options]="appStatusTypeList" appendTo="body" (onChange)="onSelectAppStatus()"
                [(ngModel)]="selectedAppStatus" placeholder="{{'SELECT'| translate}}" optionLabel="status_Description"
                [showClear]="true"></p-dropdown>
        </div>

        <div class="field col-12 md:col-3">
            <label htmlFor="selectOutletMaster">{{'SELECT_OUTLET_RD'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="contractorOutletList" [(ngModel)]="selectedOutletToGetData"
                    (onChange)="onSelectOutletToGetData()" appendTo="body"
                    placeholder="{{ 'SELECT_OUTLET_RD'| translate }}" optionLabel="Outlets"></p-dropdown>
            </div>
        </div>

        <div *ngIf="selectedOutletToGetData" class="field col-12 md:col-3">
            <label htmlFor="selectBenefitedArea">{{'BENEFITED_AREA_(IN_ACRE)'| translate}}</label>
            <div class="grid-item">
                <input type="text" class="readonly" readonly pInputText [(ngModel)]="selectedBenefitedAreaToGetData"
                    variant="filled" />
            </div>
        </div>

        <div class="field col-12 md:col-3">
            <label htmlFor="selectOutletMaster">{{'AGREEMENT_NO'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="agreementNoList" [(ngModel)]="agreementNoToGetData" appendTo="body"
                    (onChange)="onSelectAgreementNo()" placeholder="{{ 'SELECT_AGREEMENT_NO'| translate }}"
                    optionLabel="AgreementNo"></p-dropdown>
            </div>
        </div>

        <div class="field col-12 md:col-3">
            <label htmlFor="selectOutletMaster">{{'CHUNK'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="chunkList" [(ngModel)]="chunkIdToGetData" appendTo="body"
                    (onChange)="onClickGetFarmerData()" placeholder="{{ 'SELECT_CHUNK'| translate }}"
                    optionLabel="combineData"></p-dropdown>
            </div>
        </div>

        <!-- <div class="field col-12 md:col-3">
            <label></label>
            <div class="d-flex justify-content-center align-items-center vh-100 mt-2">
                <button (click)="onClickGetFarmerData()" pButton pRipple
                    label="{{ 'Get Farmer Details' | translate }}" class="p-button-success"></button>
            </div>
            <div *ngIf="!hideGetDataButton" class="d-flex justify-content-center align-items-center vh-100 mt-2">
                <button (click)="onClickGetFarmerData()" pButton pRipple
                    label="{{ 'Get Farmer Details' | translate }}" class="p-button-success"></button>
            </div>

            <div *ngIf="hideGetDataButton" class="d-flex justify-content-center align-items-center vh-100 mt-2">
                <button (click)="clearGetData()" pButton pRipple label="{{ 'Clear Details' | translate }}"
                    class="p-button-help"></button>
            </div>
        </div> -->
    </div>

    <div *ngIf="chunkIdToGetData">
        <div class="dashboardTable mt-3">
            <p *ngIf="epcDataForApproval.length > 0"
                [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem', 'text-align': 'center'}">
                {{ 'Farmer
                Details' | translate }} {{ 'of ' }}{{ this.selectedOutletToGetData?.Outlets }} {{ ' & Agreement No:'}}
                {{
                agreementNoToGetData?.AgreementNo }}</p>
            <p-table #epcDataTable [value]="epcDataForApproval" [rows]="10" [paginator]="true" [globalFilterFields]="[
            'APP_ID',
            'Applicant_type',
            'Name',
            'Father_name',
            'Aadhar_No',
            'Mobile',
            'PPP_ID',
            'MFMBNo',
            'TotalArea'
            ]" [rowHover]="true" dataKey="aadharNo"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" responsiveLayout="scroll">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-end">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="epcDataTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{'S.No'| translate}}</th>
                        <th>{{'APP_ID'| translate}}</th>
                        <th>{{'TOTAL_AREA_ACRE'| translate}}</th>
                        <th>{{'AREA_(ACRE)'| translate}}</th>
                        <!-- <th>{{'APPLICANT_TYPE'| translate}}</th> -->
                        <th>{{'FARMER_NAME'| translate}}</th>
                        <th>{{'FATHERS_NAME'| translate}}</th>
                        <th>{{'AADHAR_NO'| translate}}</th>
                        <th>{{'MOBILE_NO'| translate}}</th>
                        <th>{{'PPP_ID'| translate}}</th>
                        <th>{{'MFMB_NO'| translate}}</th>
                        <!-- <th>{{'ACTION'| translate}}</th> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-expanded="expanded" let-i="rowIndex">
                    <tr>
                        <td>{{ i + 1 }}</td>
                        <td>{{product?.APP_ID}}</td>
                        <td>{{product?.TotalArea}}</td>
                        <td>{{product?.TotalArea}}</td>
                        <!-- <td>{{product?.Applicant_type}}</td> -->
                        <td>{{product?.Name}}</td>
                        <td>{{product?.Father_name}}</td>
                        <td>{{product?.Aadhar_No}}</td>
                        <td>{{product?.Mobile}}</td>
                        <td>{{product?.PPP_ID}}</td>
                        <td>{{product?.MFMBNo}}</td>
                        <!-- <td>
                        <button pButton pRipple type="button" pTooltip="Edit-Estimation"
                            (click)="clickOnAppAction(product)" icon="pi pi-plus"
                            class="p-button-rounded p-button-text"></button>
                        <button pButton pRipple type="button" pTooltip="Delete-Estimation" icon="pi pi-times"
                            class="p-button-rounded p-button-text p-button-danger"
                            (click)="deletePersonalDetails(product)"></button>
                    </td> -->
                    </tr>
                    <!-- <tr *ngIf="expandedRows[product.landDetails]">
                    <td colspan="12">
                        <p-table [value]="product.landDetails" [rowHover]="true" responsiveLayout="scroll">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>{{'MORABBA_NUMBER'| translate}}</th>
                                    <th>{{'KILLA_NUMBER'| translate}}</th>
                                    <th>{{'Kanals'| translate}}</th>
                                    <th>{{'TOTAL_AREA'| translate}}</th>
                                    <th>{{'CROP'| translate}}</th>
                                    <th>{{'LAND_DOC'| translate}}</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-detail>
                                <tr>
                                    <td>{{detail?.morabbaNumber}}</td>
                                    <td>{{detail?.killaNumber}}</td>
                                    <td>{{detail?.kanals}}</td>
                                    <td>{{detail?.totalArea}}</td>
                                    <td>{{detail?.cropValue}}</td>
                                    <td>
                                        <a style="cursor: pointer" icon="pi pi-eye" [href]="detail?.landdoc_Path" target="_blank">
                                            <button pButton type="button"
                                                class="p-button-rounded p-button-accent p-button-secondary p-button-rounded"
                                                pTooltip="{{ 'VIEW' | translate }}" icon="pi pi-eye"></button>
                                        </a>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </td>
                </tr> -->
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">No Data found.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="summary-text">
                        <p>Outlet amount for {{ epcDataForApproval[0].Outlets }} per hectare is Rs. {{ epcDataForApproval[0].OutletAmountPerHA }}/-</p>
                    </div>
                </ng-template>
            </p-table>
        </div>

        <div class="card dashboardTable mt-3">
            <p
                [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem', 'text-align': 'center'}">
                {{ 'LAND_DETAILS' | translate }}
            </p>
            <h6 *ngIf="epcDataForAppLandDetails && epcDataForAppLandDetails.length == 0" [style]="{'font-weight': 'bold', 'color': 'black'}"> {{ 'Land Details Not Found' }}</h6>
            <div *ngIf="epcDataForAppLandDetails && epcDataForAppLandDetails.length > 0" class="dashboardTable">
                <p-table [value]="epcDataForAppLandDetails" [rows]="8" showGridlines [tableStyle]="{ 'width': '30%' }"
                    responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{'KILLA_NO' | translate}}</th>
                            <th>{{'MORABBA_NO'| translate}}</th>
                            <th>{{'LAND_DOC'| translate}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                        <tr>
                            <td class="surveyEstimateTable">{{product.Killa_No}}</td>
                            <td class="surveyEstimateTable">{{product.Morabba_No}}</td>
                            <td>
                                <a style="cursor: pointer" icon="pi pi-eye" [href]="product?.Land_Doc" target="_blank">
                                    <button pButton type="button"
                                        class="p-button-rounded p-button-accent p-button-secondary p-button-rounded"
                                        pTooltip="{{ 'VIEW' | translate }}" icon="pi pi-eye"></button>
                                </a>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>

        <div *ngIf="epcDataForApproval.length > 0" class="dashboardTable mt-5">
            <hr>
            <!-- <div class="dashboardTable mt-3"> -->
            <p *ngIf="epcDataForApproval.length > 0"
                [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem', 'text-align': 'center'}">
                {{ 'Estimation Details' | translate }}
            </p>
            <p-table #epcEstimationDataTable [value]="estimationDataForApproval" responsiveLayout="stack"
                [breakpoint]="'600px'" dataKey="id" editMode="row">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-end">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="epcEstimationDataTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width:16.66%">{{ "PROGRAMME_NAME" | translate}}</th>
                        <th style="width:16.66%">{{ "CATEGORY_NAME" | translate}}</th>
                        <th style="width:16.66%">{{ "COMPONENT_NAME" | translate}}</th>
                        <th style="width:16.66%">{{ "SIZE" | translate}}</th>
                        <th style="width:16.66%">{{ "QUANTITY" | translate}}</th>
                        <th style="width:16.66%">{{ "PER_UNIT_COST" | translate}}</th>
                        <th style="width:16.66%">{{ "TOTAL_AMOUNT" | translate}}</th>
                        <!-- <th style="width:16.66%">{{ "" | translate}}</th> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-editing="editing" let-ri="rowIndex">
                    <!-- <tr [pEditableRow]="product" [style]="{'background-color': product?.Price > 0 ? 'rgb(200, 246, 221)' : 'rgb(249, 212, 212)'}"> -->
                    <tr [pEditableRow]="product">
                        <td>{{product?.Program_Name}}</td>
                        <td>{{product?.category}}</td>
                        <td>{{product?.Component}}</td>
                        <td>{{product?.Size}}</td>
                        <td>{{product?.Quantity}}</td>
                        <td>{{product?.PerUnitCost}}</td>
                        <td>{{product?.TotalAmount}}</td>
                        <!-- <td>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input pInputText type="number" min="1" [(ngModel)]="product.Price" required [ngClass]="{
                                        'ng-invalid ng-dirty': product.Price <= 0  }" />
                                    <div class="invalid-feedback" *ngIf="product.quantityUsed <= 0">
                                        {{'Must not be greater than 0'| translate}}
                                        </div>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    <input [style]="{'background-color': 'rgb(211, 209, 209)'}" readonly pInputText
                                        type="number" [ngModel]="product.Price" />
                                </ng-template>
                            </p-cellEditor>
                        </td> -->
                        <!-- <td>
                            <div class="flex align-items-center justify-content-center gap-2">
                                <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow
                                    icon="pi pi-pencil" (click)="onRowEditInit(product)"
                                    class="p-button-rounded p-button-text">
                                </button>
                                <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow
                                    icon="pi pi-check" (click)="onRowEditSave(product)"
                                    class="p-button-rounded p-button-text p-button-success mr-2">
                                </button>
                                <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow
                                    icon="pi pi-times" (click)="onRowEditCancel(product, ri)"
                                    class="p-button-rounded p-button-text p-button-danger">
                                </button>
                            </div>
                        </td> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="footer">
                    <tr class="grand-total-row">
                      <td colspan="6" style="text-align: right; font-weight: bold;">Grand Total:</td>
                      <!-- <td>{{ grandTotalQuantity }}</td> -->
                      <td>{{ grandTotalCost  | currency:'INR' }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <div *ngIf="epcDataForApproval.length > 0" class="card submit-card mt-2">
            <div class="p-fluid p-formgrid grid">
                <div class="col-12 md:col-3">
                    <p-dropdown [options]="items" [(ngModel)]="selectedStatus"
                        (onChange)="onSelectStatus()" placeholder="{{ 'ACTION_TYPE'| translate }}" optionLabel="status" class="mr-3">
                    </p-dropdown>
                </div>
                <div *ngIf="selectedStatus && !isRPCase" class="col-12 md:col-3">
                    <p-dropdown [options]="jeList" [(ngModel)]="selectedJE" placeholder="{{ 'Next User'| translate }}"
                        optionLabel="UserID" class="mr-3">
                    </p-dropdown>
                </div>
                <div class="col-12 md:col-3">
                    <textarea id="description" [(ngModel)]="remarks" placeholder="Remarks" pInputTextarea required
                        rows="3" cols="20" class="mr-3"></textarea>
                </div>
                <div class="col-12 md:col-3">
                    <button [disabled]="!selectedStatus" pButton pRipple label="Submit" (click)="onClickSubmit()"
                        class="p-button-success"></button>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- <p-dialog header="EPC App Action" [baseZIndex]="-1000" [(visible)]="showActionDialog" [modal]="true" [style]="{width: '85%',height:'100%'}"
    [maximizable]="true" [draggable]="false" [resizable]="false" (onHide)="onCloseActionDialog()">
</p-dialog> -->

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>